<script lang="ts">
    import { Row, Col } from "sveltestrap";
    import Card from "../../Core/Card.svelte";
    import icoData from "../../../Data/IconsData/IcoIcon.json"
    import { FoodIcons } from "../../../utils/Constant/Constant";
    import {iTag,icons,iconClick} from "../../../store"
    function getItag(tag:any) {
        iTag.update(value => value = `<i class="icofont icofont-${tag}" ></i>`);
        icons.update(value=> value = `icofont icofont-${tag}`) ;
        iconClick.update(value => value = true);
    }
</script>

<Row>
    <Col sm="12">
        <Card headerTitle={FoodIcons} cardHeaderprops="pb-0">
            <div slot="contentbody">
                <Row class="icon-lists">
                    {#each icoData[0].food as icon}
                        <Col sm="6" lg="4">
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <span on:click={() => getItag(icon)}>
                                <i class={`icofont icofont-${icon}`}></i> {icon}
                            </span>
                        </Col>
                    {/each}
                </Row>
            </div>
        </Card>
    </Col>
</Row>
